// extracted by mini-css-extract-plugin
export default {"load":"LoadImg_load__nkYeL","animation":"LoadImg_animation__2HPth","radius":"LoadImg_radius__xf5g3"};